import { AbstractControl, Validators } from '@angular/forms';

export type BooleanFn = () => boolean;

export class NgxValidators {
  static requiredIf(predicate: BooleanFn, inputName?: string) {
    return (formControl => {
      if (!formControl.parent) {
        return null;
      }
      if (predicate()) {
        return Validators.required(formControl);
      }
      return null;
    });
  }

  static matchPasswords(passwordFieldName: string, retypedPasswordFieldName: string) {
    return (control: AbstractControl): { [key: string]: boolean } | null => {
      const password = control.parent?.get(passwordFieldName).value;
      const retypedPassword = control.parent?.get(retypedPasswordFieldName).value;
    
      if (password === retypedPassword) {
        return null;
      } else {
        return { passwordMismatch: true };
      }
    };
  }

  static uniqueIgnoreCaseAmong(comparisonSet: string[]) {
    return (control: AbstractControl): { [key: string]: boolean } | null => {
      const value: string = control.value;
      const elementAlreadyExists = comparisonSet.some(element => element.toLowerCase() === value.toLowerCase());
      return elementAlreadyExists ? { isNotUnique: true } : null;
    };
  }

  static isinExists(comparisonSet: string[]) {
    return (control: AbstractControl): { [key: string]: boolean } | null => {
      const value: string = control.value;
      const elementAlreadyExists = comparisonSet.some(element => element.toLowerCase() === value.toLowerCase());
      return elementAlreadyExists ?  null : { isinDoesntExist: true };
    };
  }
}
